import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {  fetchAssignkiosk } from "../../../service/api";

export const getAssignKiosk = createAsyncThunk(
    "event/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAssignkiosk(params)
            console.log("kiosk ", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


const kioskSlice = createSlice({
    name: "kiosk",
    initialState: {
        assignKiosk: [],
        isLoading: false,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: "",
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        }
    },

    extraReducers: (builder) => {
        builder
            //GET
            .addCase(getAssignKiosk.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getAssignKiosk.fulfilled, (state, action) => {
                state.isLoading = false;
                state.assignKiosk = action.payload.data;
                state.totalPage = action.payload.totalPages
            })

            .addCase(getAssignKiosk.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            
    }
})
export const { setSearchParams, setPagination } = kioskSlice.actions;

export default kioskSlice.reducer;
